import React from 'react';

const HeartIcon = ({
  width = 18,
  height = 18,
  fillColor = 'none',
  color = 'black',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.4725 39.2268C25.0793 40.4917 22.9344 40.4917 21.5412 39.2084L21.3396 39.0251C11.7154 30.3175 5.42753 24.6163 5.66585 17.5035C5.77584 14.3871 7.37071 11.399 9.9555 9.63917C14.7951 6.33944 20.7713 7.87931 23.9977 11.6557C27.2241 7.87931 33.2003 6.32111 38.0399 9.63917C40.6247 11.399 42.2195 14.3871 42.3295 17.5035C42.5862 24.6163 36.28 30.3175 26.6558 39.0618L26.4725 39.2268Z"
      stroke={color}
      fill={fillColor}
      stroke-width="2.4998"
    />
  </svg>
);

export default HeartIcon;
